import * as React from "react";
import { AddToCart } from "@grandvisionhq/carts-v2";
import { Text } from "@grandvisionhq/elements";
import { useIntl } from "@grandvisionhq/state";
import { isDefined } from "@grandvisionhq/utils";
import { SubscriptionDailyIntervalPriceCaption } from "../../../../../../../../../../../../components/CTAs/components/modules/EcommContent/components/CTAs/components/SubscriptionDailyIntervalPriceCaption.js";
import { SinglePurchasePriceCaption } from "../../../../../../../../../../../../components/CTAs/components/modules/EcommContent/components/CTAs/components/SinglePurchasePriceCaption.js";
const PricedAddToCartCTA = ({ price, isCentAmount, priceInterval, ...props }) => {
  const { getLabel } = useIntl();
  return /* @__PURE__ */ React.createElement(
    AddToCart,
    {
      caption: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Text, { component: "span", variant: "body" }, getLabel("products.actions.addToCart")), /* @__PURE__ */ React.createElement(PriceCaption, { price, priceInterval, isCentAmount })),
      ...props
    }
  );
};
const PriceCaption = ({
  price,
  isCentAmount,
  priceInterval
}) => {
  if (!isDefined(price)) return null;
  if (isDefined(priceInterval)) {
    return /* @__PURE__ */ React.createElement(
      SubscriptionDailyIntervalPriceCaption,
      {
        price,
        isCentAmount,
        priceInterval
      }
    );
  }
  return /* @__PURE__ */ React.createElement(SinglePurchasePriceCaption, { price, isCentAmount });
};
export {
  PricedAddToCartCTA
};
//# sourceMappingURL=PricedAddToCartCTA.js.map
